export default {
  setIframePopupSrc(state, payload) {
    state.iframe_src = payload;
  },
  setIframePopupTitle(state, payload) {
    state.iframe_title = payload;
  },
  setIframePopupVisible(state, payload) {
    state.iframe_visible = payload;
  },
  setVideoPopupSrc(state, payload) {
    state.video_src = payload;
  },
  setVideoPopupTitle(state, payload) {
    state.video_title = payload;
  },
  setVideoPopupCaptions(state, payload) {
    state.video_captions = payload;
  },
  setVideoPopupTranscript(state, payload) {
    state.video_transcript = payload;
  },
  setVideoPopupVisible(state, payload) {
    state.video_visible = payload;
  },
  setHelpPopupVisible(state, payload) {
    state.help_popup_visible = payload;
  },
  setFocusElemOnPopupClose(state, payload) {
    state.focusElemOnPopupClose = payload;
  },
};
